import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  beneTxnAccountDetail,
  resetBeneTxnMultiApprovalError,
  resetBeneTxnMultiDeniedApprovalData,
} from "../../../../redux/features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import formatDateViewAll from "../../../../utils/formatDateViewAll";
import CardContainer from "../../../_utils/CommonViewAllCard/CardContainer";
import TextWithCTA from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithCTA";
import TextWithIcon from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";

const BeneTransactionMultiApprovalCard = ({
  filterOpen,
  data,
  setselectAllCard,
  selectedTransactions,
  setSelectedTransactions,
  setTotalAmount,
  setSelectedSendTransactions,
  selectedSendTransactions,
  SetBeneTxnDetailsId,
  setTxnId,
  openBeneTxnDetailModal,
  isDrawerOpen,
  setisDrawerOpen,
  setBeneAccountStatus,
  filterRef,
}) => {
  const [txnData, setTxnData] = useState([]);
  const dispatch = useDispatch();

  const {
    beneTxnAccountData,
    BeneTxnMultiApprovalError,
    BeneTxnMultiDeniedApprovalError,
  } = useSelector((state) => state?.beneTxnViewAccData);

  useEffect(() => {
    dispatch(resetBeneTxnMultiApprovalError());
    dispatch(resetBeneTxnMultiDeniedApprovalData());
  }, [BeneTxnMultiApprovalError, BeneTxnMultiDeniedApprovalError]);

  useEffect(() => {
    setTxnData({
      ...txnData,
      owner_account_balance_last_fetched_at_in_words:
        beneTxnAccountData?.transaction[0]
          ?.owner_account_balance_last_fetched_at_in_words,
      owner_account_balance:
        beneTxnAccountData?.transaction[0]?.owner_account_balance,
      owner_account_balance_last_fetched_at:
        beneTxnAccountData?.transaction[0]
          ?.owner_account_balance_last_fetched_at,
    });
  }, [beneTxnAccountData]);

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--settled)";
      case "denied":
      case "blocked":
        return "var(--failed)";
      case "archived":
        return "var(--abandoned)";
      default:
        return "var(--settled)";
    }
  };

  const SideDrawerOpen = async (id, txnId, status) => {
    SetBeneTxnDetailsId(id);
    setisDrawerOpen(!isDrawerOpen);
    setBeneAccountStatus(status);
    await dispatch(beneTxnAccountDetail(txnId));
  };

  const handleCardClick = (transaction) => {
    if (transaction.beneficiary_account_approval_status === "approved") {
      setselectAllCard(false);
      setSelectedTransactions((prevSelected) => {
        const cardAmount = Number(transaction.amount);
        const isSelected = prevSelected.includes(transaction.txn_id);

        if (isSelected) {
          setTotalAmount((prevAmount) => prevAmount - cardAmount);
          let data = selectedSendTransactions.filter((val) => {
            return val?.txn_id !== transaction.txn_id;
          });
          setSelectedSendTransactions(data);
          return prevSelected.filter((id) => id !== transaction.txn_id);
        } else {
          if (prevSelected.length < GlobalConfiguration?.categorymaxLength) {
            setTotalAmount((prevAmount) => prevAmount + cardAmount);
            setSelectedSendTransactions((prev) => [...prev, transaction]);
            return [...prevSelected, transaction.txn_id];
          } else {
            return prevSelected;
          }
        }
      });
    }
  };

  return (
    <>
      <div className="standard-card-alignment gap-x-gap-sm gap-y-gap-md">
        {data?.map((transaction) => {
          return (
            <CardContainer
              filterRef={filterRef}
              hoverHeight={
                GlobalConfiguration?.beneTxnMultiApprovalCardHoverHeight
              }
              isDisabled={
                filterOpen ||
                transaction.beneficiary_account_approval_status === "pending"
                  ? true
                  : false
              }
              key={transaction?.txn_id}
              isSelected={selectedTransactions.includes(transaction.txn_id)}
              onClickHandler={() => handleCardClick(transaction)}
            >
              <card-body>
                <TextWithIcon
                  type={
                    transaction.beneficiary_account_approval_status ===
                    "pending"
                      ? "Text"
                      : "Amount"
                  }
                  fontWeight={"semibold"}
                  text={
                    transaction.beneficiary_account_approval_status ===
                    "pending"
                      ? "Account approval pending"
                      : transaction?.amount
                  }
                  textColor={getStatusColor(
                    transaction.beneficiary_account_approval_status,
                  )}
                  subText={
                    transaction.beneficiary_account_approval_status ===
                    "pending"
                      ? "Account status"
                      : "Transaction amount"
                  }
                  iconComponentArray={
                    transaction.beneficiary_account_approval_status !==
                    "pending"
                      ? [
                          ...(transaction?.confidential_transaction === "Y"
                            ? [
                                {
                                  icon: "https://q2pay.in/new_assets/common/detail_page/confidential_transaction.svg",
                                  title: "confidential",
                                  isDisabled: false,
                                },
                              ]
                            : []),

                          {
                            icon: selectedTransactions.includes(
                              transaction?.txn_id,
                            )
                              ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                              : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg",
                            isDisabled: false,
                          },
                        ]
                      : []
                  }
                />
                <TextWithIcon
                  type={"Text"}
                  fontWeight={
                    transaction.beneficiary_account_approval_status ===
                    "pending"
                      ? "var(--font-normal)"
                      : "var(--font-semibold)"
                  }
                  text={transaction.beneficiary_account_name
                    .toLowerCase()
                    .split(" ")
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" ")}
                  textColor={"var(--text-primary)"}
                  subText="Beneficiary name"
                />
                <TextWithCTA
                  btnText={
                    transaction.beneficiary_account_approval_status ===
                    "pending"
                      ? "Approve account"
                      : "Addtional details"
                  }
                  enabledBgColor={"var(--text-primary)"}
                  enabledTextColor={"var(--primary-bg)"}
                  handleFunction={(e) => {
                    e.stopPropagation();

                    setTxnData(transaction);

                    if (!sessionStorage.getItem("q2p_token")) {
                      setisDrawerOpen(false);

                      return;
                    }
                    if (
                      transaction.beneficiary_account_approval_status ===
                      "pending"
                    ) {
                      SideDrawerOpen(
                        transaction?.beneficiary_account_id,
                        transaction?.txn_id,
                        transaction?.beneficiary_account_approval_status,
                      );
                    } else {
                      openBeneTxnDetailModal();
                      setTxnId(transaction.txn_id);
                    }
                  }}
                  icon={
                    "https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
                  }
                  isDisabled={filterOpen ? true : false}
                  text={
                    transaction.created_on
                      ? formatDateViewAll(transaction.created_on, false, false)
                      : "Not given"
                  }
                  subText="Date"
                />
              </card-body>
              <card-hover>
                <TextWithIcon
                  text={transaction?.labels?.join(", ") || "No labels assigned"}
                  fontWeight={"normal"}
                  textColor={"var(--text-primary)"}
                  iconComponentArray={[
                    {
                      icon: "https://q2pay.in/new_assets/common/view_all/label.svg",
                    },
                  ]}
                />
              </card-hover>
            </CardContainer>
          );
        })}
      </div>
    </>
  );
};

export default BeneTransactionMultiApprovalCard;
